import { useState, useEffect } from 'react';

export const useFormValidation = (...formFields: string[]) => {
  const [isDataFill, setIsDataFill] = useState(false);

  useEffect(() => {
    for (const formField of formFields) {
      if (formField === '') {
        setIsDataFill(false);
        return;
      }
    }
    setIsDataFill(true);
  }, [formFields]);

  return isDataFill;
};
